import * as React from 'react';

import { useInfiniteScroll } from '@blockworks/ui/legacy/utils';

import { withExceptionCatcher } from '@/components/hoc/with-exception-catcher';
import WebinarsPageLayout from '@/components/pages/webinars/layout/webinars-page-layout';
import { WebinarStripped } from '@/types/article-type';

export interface PodcastPageControllerProps {
    webinars: WebinarStripped[];
}

export const WebinarsPageController = ({ webinars: initialWebinars }: PodcastPageControllerProps) => {
    const { entities, lastElementRef, isLoading } = useInfiniteScroll(
        initialWebinars,
        async (limit, page) => {
            const response = await fetch(`/api/webinars?page=${page}&limit=${limit}`);
            const newWebinars = await response.json();
            return newWebinars;
        },
        8,
    );
    const now = Math.floor(Date.now() / 1000);
    const upcoming = entities.filter(w => w.date > now).sort((a, b) => (a.date ?? 0) - (b.date ?? 0));
    const pastWebinars = entities.filter(w => w.date <= now);

    return (
        <WebinarsPageLayout
            upcoming={upcoming}
            pastWebinars={pastWebinars}
            lastElementRef={lastElementRef}
            isLoading={isLoading}
        />
    );
};

export default withExceptionCatcher(WebinarsPageController);
